import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonLoading, FormCheck } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { apiOrganization } from "../../../../../../../services/Api/Organization/apiOrganization";

interface Props {
	show: boolean;
	onHide: () => void;
}

interface RebuildForm {
	INVOICE: boolean;
	TRANSACTION: boolean;
	ITEM: boolean;
	ORDER_PREPARATION_STATUS_CHANGE: boolean;
	ORDER: boolean;
	WORK_TIME: boolean;
}

export const RebuildReportModal = ({ show, onHide }: Props) => {
	const [loading, setLoading] = useState(false);
	const { t } = useTranslation();
	const { addSuccessFlash, addFlash } = useFlash();
	const form = useForm<RebuildForm>();
	const {
		register,
		handleSubmit,
		formState: { errors },
		reset,
	} = form;

	const onSubmit = handleSubmit(async (data: RebuildForm) => {
		setLoading(true);
		try {
			const reportTypesToRebuild = Object.entries(data)
				.filter(([_, applyReportType]: [string, boolean]) => applyReportType)
				.map(([reportType]) => reportType)
				.join(",");
			await apiOrganization.rebuildReport(reportTypesToRebuild);
			addSuccessFlash(t("lib:common.flash.completed"));
			reset({
				INVOICE: false,
				ITEM: false,
				ORDER_PREPARATION_STATUS_CHANGE: false,
				ORDER: false,
				WORK_TIME: false,
				TRANSACTION: false,
			});
		} catch (err) {
			handleError.alert(err, addFlash);
		}
		setLoading(false);
	});

	return (
		<Modal show={show} onHide={onHide}>
			<Form>
				<Modal.Header>
					<Modal.Title>Przebuduj</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<FormCheck label="INVOICE" name="INVOICE" register={register} errors={errors} />
					<FormCheck label="TRANSACTION" name="TRANSACTION" register={register} errors={errors} />
					<FormCheck label="ORDER" name="ORDER" register={register} errors={errors} />
					<FormCheck label="ITEM" name="ITEM" register={register} errors={errors} />
					<FormCheck label="WORK_TIME" name="WORK_TIME" register={register} errors={errors} />
					<FormCheck
						label="ORDER_PREPARATION_STATUS_CHANGE"
						name="ORDER_PREPARATION_STATUS_CHANGE"
						register={register}
						errors={errors}
					/>
				</Modal.Body>
				<Modal.Footer>
					<ButtonLoading loading={loading} onClick={onSubmit} type="submit">
						{t("modules.report.action.rebuild.title")}
					</ButtonLoading>
					<Button variant="light" onClick={onHide}>
						{t("common.action.cancel", { ns: "lib" })}
					</Button>
				</Modal.Footer>
			</Form>
		</Modal>
	);
};
